import { render, staticRenderFns } from "./CODE_SNIPPET.vue?vue&type=template&id=0cf3a0b4&"
import script from "./CODE_SNIPPET.vue?vue&type=script&lang=js&"
export * from "./CODE_SNIPPET.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports